import { useQuery } from '@tanstack/react-query'

import { getDepositRestrictions } from '@src/api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'

export const useFetchDepositRestrictions = (params: {
  // Used for cache key differentiation even though API doesn't take parameters
  organizationId: string
}) => {
  const { axiosInstance } = useAxios()

  return useQuery({
    enabled: !!params.organizationId,
    queryFn: () => getDepositRestrictions(axiosInstance),
    // Note: organizationId is included in queryKey for cache management
    // even though the API doesn't take parameters. This ensures proper
    // cache separation in case data doesn't change on login/logout.
    queryKey: [
      REACT_QUERY_CACHE_KEYS.GET_DEPOSIT_RESTRICTIONS,
      params.organizationId,
    ],
  })
}
